export default __webpack_public_path__ + "static/media/icon-21.700ec065.png";